// extracted by mini-css-extract-plugin
export default {"ResourceLabelsCard":"ResourceLabelsCard___Z8hKK","ResourceLabelsCard_hasData":"ResourceLabelsCard_hasData___VCwgw","readOnly":"readOnly___PQHBM"};